var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C01818",
    fillRule: "evenodd",
    d: "M17.878 23.989l1.566 1.567L25 20l-5.556-5.556-1.566 1.567 2.866 2.878H10v2.222h10.744l-2.866 2.878zM27.778 10H12.222C10.99 10 10 11 10 12.222v4.445h2.222v-4.445h15.556v15.556H12.222v-4.445H10v4.445C10 29 10.989 30 12.222 30h15.556C29 30 30 29 30 27.778V12.222C30 11 29 10 27.778 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a8b3a91d5cf5d84ce28190f4fff128f2.svg";
export { ForwardRef as ReactComponent };